export class ProductWiseStockReq{
    product?:string
    grade?:string
    constructor(
        product?:string,
    grade?:string
    ){
this.product = product
this.grade = grade
    }
}